import { render } from "./MoneyAmount.vue?vue&type=template&id=49304b34&scoped=true&ts=true"
import script from "./MoneyAmount.vue?vue&type=script&lang=ts"
export * from "./MoneyAmount.vue?vue&type=script&lang=ts"

import "./MoneyAmount.vue?vue&type=style&index=0&id=49304b34&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49304b34"]])

export default __exports__